/** PURE_IMPORTS_START .._operators_publish PURE_IMPORTS_END */
import { publish as higherOrder } from '../operators/publish';
/* tslint:enable:max-line-length */
/**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */
export function publish(selector) {
    return higherOrder(selector)(this);
}
//# sourceMappingURL=publish.js.map 



//////////////////
// WEBPACK FOOTER
// ./~/rxjs/_esm5/operator/publish.js
// module id = 839
// module chunks = 0